<template>
  <div
    v-if="count"
    class="text-xs-bold mod--cha-number LKIconCount"
    v-text="count"
  />
</template>

<script>
export default {
  name: 'LKIconCount',
  props: {
    count: [Number, String],
  },
}
</script>

<style lang="scss">
.LKIconCount {
  &.mod--cha-number {
    width: auto !important;
    min-width: 20px;
    padding: 4px;
    border-radius: 10px !important;
    transform: translateY(-10px);
  }
}
</style>
